module.exports = __webpack_public_path__ + "img/Strategy.bfa6abfb.png";